import Alpine from 'alpinejs';

Alpine.data('labelReveal', () => {
  return {
    active: null,
    init() {
      const checked = this.$el.querySelector('input:checked');
      if (checked) this.active = checked.value;
    },
  };
});

Alpine.registerModule('labelReveal');
